// extracted by mini-css-extract-plugin
export default {"TButtom":"TButtom_c8mU8"};